export const LOAD_TRANSACTION_RULES = 'LOAD_TRANSACTION_RULES'
export const RECEIVE_TRANSACTION_RULES = 'RECEIVE_TRANSACTION_RULES'
